import React from 'react';
import { useTranslation } from 'react-i18next';
import ProductCard from './ProductCard';
import RiskFixerCard from './RiskFixerCard';
import './ProductsSection.css';

const ProductsSection = () => {
  const { t } = useTranslation();

  const products = [
    {
      key: 'traderPro',
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M3 3v18h18"></path>
          <path d="M18.7 8l-5.1 5.2-2.8-2.7L7 14.3"></path>
        </svg>
      ),
      gradient: 'gradient-blue'
    },
    {
      key: 'tideLab',
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M9 12l2 2 4-4"></path>
          <path d="M21 12c-1 0-2-1-2-2s1-2 2-2 2 1 2 2-1 2-2 2z"></path>
          <path d="M3 12c1 0 2-1 2-2s-1-2-2-2-2 1-2 2 1 2 2 2z"></path>
          <path d="M12 3c0 1-1 2-2 2s-2-1-2-2 1-2 2-2 2 1 2 2z"></path>
          <path d="M12 21c0-1 1-2 2-2s2 1 2 2-1 2-2 2-2-1-2-2z"></path>
          <circle cx="12" cy="12" r="3"></circle>
        </svg>
      ),
      gradient: 'gradient-cyan'
    },
    {
      key: 'riskFixer',
      component: 'RiskFixerCard',
      special: true
    },
    {
      key: 'wallet',
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="2" y="4" width="20" height="16" rx="2"></rect>
          <path d="M2 10h20"></path>
          <circle cx="16" cy="12" r="2"></circle>
        </svg>
      ),
      gradient: 'gradient-orange'
    },
    {
      key: 'tideAlert',
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
          <line x1="12" y1="9" x2="12" y2="13"></line>
          <line x1="12" y1="17" x2="12.01" y2="17"></line>
        </svg>
      ),
      gradient: 'gradient-purple'
    }
  ];

  return (
    <section id="products" className="products-section section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title fade-in-up">我们的核心产品</h2>
          <p className="section-subtitle fade-in-up">
            为 Web3 交易者与投资者提供完整的链上工具生态
          </p>
        </div>
        
        <div className="products-grid">
          {products.map((product, index) => (
            <div 
              key={product.key} 
              className="product-wrapper fade-in-up"
              style={{ animationDelay: `${index * 0.2}s` }}
            >
              {product.special && product.component === 'RiskFixerCard' ? (
                <RiskFixerCard />
              ) : (
                <ProductCard
                  productKey={product.key}
                  icon={product.icon}
                  gradient={product.gradient}
                />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductsSection; 